export function trace(opts?: { links?: boolean }): string[] {
    opts = opts || {}
    try { throw new Error() }
    catch (err) {
        return String(err.stack)
            .split(/[\n\r]+\s*(?:at|@)\s*/ig)
            .slice(2)
            .map(line => opts.links ? line : line.replace(/^([^(]+)[\s\S]+$/, '$1').trim())
    }
}

export const CALL_INTO_SYMBOL = '⥂'

export function callers(matcher: string | RegExp = '', limit = 3): string {
    if (typeof matcher === 'string') {
        let lowerCaseMatcher = matcher.toLowerCase()
        return trace().slice(2).filter(line => ~line.toLowerCase().indexOf(lowerCaseMatcher)).slice(0, limit).reverse().join('⥂')

    } else if (matcher instanceof RegExp) {
        return trace().slice(2).filter(line => matcher.test(line)).slice(0, limit).reverse().join(CALL_INTO_SYMBOL)

    } else {
        return trace().slice(2, 2 + limit).reverse().join(CALL_INTO_SYMBOL)
    }
}

export function caller(): string {
    // return the caller
    return trace()[2]
}
